import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MzToastService } from "ng2-materialize";

import { environment } from "../../../environments/environment";
import { User } from "../../interfaces/user";
import { SessionService } from "../session/session.service";
import { UserService } from "../user/user.service";

type LoginResponse = {
  token: string;
  roles: string[];
  startedTrial: boolean;
};

@Injectable()
export class AuthService {
  constructor(
    private http: HttpClient,
    private session: SessionService,
    private userService: UserService,
    private toastService: MzToastService
  ) {}

  async login({ email, password }, rememberMe) {
    const response = await this.http
      .post<LoginResponse>(
        environment.managirUrl + "/actions/login",
        {
          email: email,
          password: password,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .toPromise();

    // this needs to be set before we grab the user!
    this.session.setToken(response.token, rememberMe, response.roles);

    const user = (await this.userService.getUser()) as User;

    if (response.startedTrial)
      this.toastService.show("30 Tage Trial wurde gestartet.", 10000);

    this.session.setHasActiveLicense(this.hasActiveLicense(user));

    this.setInitialsToSession(user);

    return user.numberOfLogins <= 1;
  }

  private hasActiveLicense(user: User) {
    switch (user.licenseStatus) {
      case "active":
      case "trialing":
        return true;
      case "company":
        return new Date(user.licensePeriodEnd) > new Date();
      case "canceled":
      default:
        return false;
    }
  }

  private setInitialsToSession(user: User) {
    let initials = "";
    if (user.lastName && user.lastName.length > 0)
      initials += user.firstName.charAt(0).toUpperCase();

    if (user.lastName && user.lastName.length > 0)
      initials += user.lastName.charAt(0).toUpperCase();

    if (initials.length === 0) initials = "?";

    this.session.setInitials(initials);
  }

  public async logout() {
    try {
      await this.http
        .post<any>(
          environment.managirUrl + "/actions/logout",
          {},
          { headers: { "Content-Type": "application/json" } }
        )
        .toPromise();
    } finally {
      localStorage.setItem("logout", "true");
      this.session.destroy();
    }
  }

  public isLoggedIn(): boolean {
    if (this.session.getToken()) {
      return true;
    }
    return false;
  }

  public isSubscribed(): boolean {
    return this.session.getHasActiveLicense();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/auth/auth.service.ts